import { THEME } from '../config/constants'
import { Service } from '../types'

export const useServiceData = () => {
  const data: Record<string, Service> = {
    resume_crafting: {
      id: 'resume_crafting',
      title: 'Resume crafting',
      defaultActive: true,
      progress: 0,
      icon: 'ResumeCrafting',
      component: 'ResumeCrafting',
      theme: THEME.documents,
      data: {},
    },
    resume_tailoring: {
      id: 'resume_tailoring',
      title: 'Resume tailoring',
      defaultActive: false,
      progress: 0,
      icon: 'ResumeTailoring',
      component: 'ResumeTailoring',
      theme: THEME.documents,
      data: {},
    },
    resume_distribution: {
      id: 'resume_distribution',
      title: 'Resume distribution',
      defaultActive: false,
      progress: 0,
      icon: 'ResumeDistribution',
      component: 'ResumeDistribution',
      theme: THEME.documents,
      data: {},
    },
    cover_letter_crafting: {
      id: 'cover_letter_crafting',
      title: 'Cover letter crafting',
      defaultActive: false,
      progress: 0,
      icon: 'CoverLetterCrafting',
      component: 'CoverLetterCrafting',
      theme: THEME.documents,
      data: {},
    },
    job_applications: {
      id: 'job_applications',
      title: 'Jobs applied for',
      defaultActive: true,
      progress: 0,
      icon: 'JobsApplied',
      component: 'JobsApplied',
      theme: THEME.jobs,
      data: {},
    },
    job_search_strategy: {
      id: 'job_search_strategy',
      title: 'Job search strategy',
      defaultActive: false,
      progress: 0,
      icon: 'JobSearchStrategy',
      component: 'JobSearchStrategy',
      theme: THEME.careers,
      data: {},
    },

    interviews_started: {
      id: 'interviews_started',
      title: 'Interviews practiced',
      defaultActive: true,
      progress: 0,
      icon: 'InterviewsPracticed',
      component: 'InterviewsPracticed',
      theme: THEME.careers,
      data: {},
    },
    interview_questions: {
      id: 'interview_questions',
      title: 'Questions practiced',
      defaultActive: false,
      progress: 0,
      icon: 'QuestionsPracticed',
      component: 'QuestionsPracticed',
      theme: THEME.careers,
      data: {},
    },
    interview_strategy: {
      id: 'interview_strategy',
      title: 'Interview strategy',
      defaultActive: false,
      progress: 0,
      icon: 'InterviewStrategy',
      component: 'InterviewStrategy',
      theme: THEME.careers,
      data: {},
    },
    interviews_completed: {
      id: 'interviews_completed',
      title: 'Interviews passed',
      defaultActive: false,
      progress: 0,
      icon: 'InterviewsPassed',
      component: 'InterviewsPassed',
      theme: THEME.careers,
      data: {},
    },
    ninety_days_plan: {
      id: 'ninety_days_plan',
      title: 'First 90 days plan',
      defaultActive: true,
      progress: 0,
      icon: 'First90DaysPlan',
      component: 'First90DaysPlan',
      theme: THEME.careers,
      data: {},
    },
    promotion_plan: {
      id: 'promotion_plan',
      title: 'Get a promotion',
      defaultActive: false,
      progress: 0,
      icon: 'GetPromotion',
      component: 'GetPromotion',
      theme: THEME.careers,
      data: {},
    },
    career_switch: {
      id: 'career_switch',
      title: 'Change careers',
      defaultActive: false,
      progress: 0,
      icon: 'ChangeCareers',
      component: 'ChangeCareers',
      theme: THEME.careers,
      data: {},
    },
  }

  return data
}
